import { RootState } from "@/store";
import React from "react";
import { useSelector } from "react-redux";

interface Step {
  number: number;
  label: string;
}

const steps: Step[] = [
  { number: 2, label: "Beneficiaries" },
  { number: 3, label: "Goals" },
  { number: 4, label: "Contributions" },
  { number: 5, label: "Plan" },
];

const ProgressIndicator: React.FC = () => {
  const currentStep = useSelector(
    (state: RootState) => state.wizard.currentStep,
  );

  return (
    <div className="md:shadow-md bg-white shadow-wrapper border border-[#E2E2E2] rounded-[56px] py-[6px] px-[8px] mb-[24px]">
      <div className="flex space-x-[12px] text-[16px] leading-[127%] font-normal">
        {steps.map((step) => (
          <div
            key={step.number}
            className={`transition duration-500 ease-in-out h-[36px] rounded-[56px] flex items-center space-x-[8px] pl-[8px] pr-[12px] ${
              step.number === currentStep
                ? "bg-brand-default shadow-buttonPrimary"
                : ""
            }`}
          >
            <div
              className={`font-bold transition duration-500 ease-in-out w-[24px] rounded-full h-[24px] flex items-center justify-center ${
                step.number === currentStep
                  ? "bg-[#008281] text-white"
                  : "bg-brand-default/10 text-[#00ADAC]"
              }`}
            >
              {step.number - 1}
            </div>
            {/* Show label by default only for current step, show all labels on sm breakpoint */}
            <span
              className={`transition duration-500 ease-in-out ${
                step.number === currentStep
                  ? "inline text-white font-semibold"
                  : "hidden sm:inline text-[#00ADAC]"
              }`}
            >
              {step.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressIndicator;
